import { format } from 'date-fns';
import { ja } from 'date-fns/locale';
import { useState } from 'react';
import useCandidateImportHistory from '../api/useCandidateImportHistory';

export function CandidateImportRequestsHistoryTab() {
  const [page, setPage] = useState(1);
  const { data, isLoading } = useCandidateImportHistory(page);

  if (isLoading) {
    return (
      <div className="space-y-md">
        <h2 className="text-heading-md">取り込み履歴</h2>
        <div className="rounded-sm bg-gray p-x3l text-center">
          <p className="text-body-md text-sub">読み込み中...</p>
        </div>
      </div>
    );
  }

  const historyList = data?.records || [];

  return (
    <div className="space-y-md">
      {/* ヘッダー */}
      <h2 className="text-heading-md">取り込み履歴</h2>

      {/* 履歴一覧 */}
      {historyList.length === 0 ? (
        <div className="rounded-sm bg-gray p-x3l text-center">
          <p className="text-body-md text-sub">取り込み履歴がありません。</p>
        </div>
      ) : (
        <>
          <div className="flex flex-col">
            {/* ヘッダー行 */}
            <div className="flex items-center gap-x-lg border-b border-solid border-border bg-gray px-md py-xxs">
              <div className="w-40 text-body-sm font-bold text-sub">日時</div>
              <div className="flex-1 text-body-sm font-bold text-sub">操作者</div>
              <div className="w-[200px] text-left text-body-sm font-bold text-sub">
                利用した設定
              </div>
            </div>

            {/* データ行 */}
            {historyList.map((item) => (
              <div
                key={item.id}
                className="flex items-center gap-x-lg border-b border-solid border-border bg-white px-md py-sm"
              >
                <div className="w-40 text-body-sm whitespace-nowrap">
                  {item.created_at
                    ? format(new Date(item.created_at), 'yyyy/MM/dd HH:mm:ss', {
                        locale: ja,
                      })
                    : '-'}
                </div>
                <div className="flex-1 text-body-sm">{item.operator_name || '-'}</div>
                <div className="w-[200px] text-body-sm">{item.template_title || '-'}</div>
              </div>
            ))}
          </div>

          {/* ページネーション */}
          {data && data.total_pages > 1 && (
            <div className="flex items-center justify-center gap-x-sm">
              <button
                onClick={() => setPage(page - 1)}
                disabled={data.is_first_page}
                className="rounded-sm border border-solid border-border bg-white px-md py-xs text-body-sm disabled:cursor-not-allowed disabled:opacity-50"
              >
                前へ
              </button>
              <span className="text-body-sm">
                {data.current_page} / {data.total_pages}
              </span>
              <button
                onClick={() => setPage(page + 1)}
                disabled={data.is_last_page}
                className="rounded-sm border border-solid border-border bg-white px-md py-xs text-body-sm disabled:cursor-not-allowed disabled:opacity-50"
              >
                次へ
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
